import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useAuth } from "../context/AuthContext";

const customIcon = new L.Icon({
  iconUrl: "../images/pin.png", // example pin
  iconSize: [50, 50],
  iconAnchor: [17, 35],
});

const MapWithOffset = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    map.setView(center, 20);
  }, [center, map]);

  return <Marker position={center} icon={customIcon} />;
};

const MyMap = () => {
  const { chatData } = useAuth();
  const markerPosition = [parseFloat(chatData?.lat), parseFloat(chatData?.lon)];

  const center = [chatData?.lat, chatData?.lon];

  return (
    // <div>
    //   <div>
    //     <p className="relative z-40">hgekls</p>
    //   </div>
    //   <MapContainer
    //     center={center}
    //     zoom={20}
    //     style={{ height: "300px", width: "100%" }}
    //     zoomControl={false}
    //   >
    //     <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    //     <MapWithOffset center={markerPosition} />
    //   </MapContainer>
    // </div>
    <div style={{ position: "relative" }}>
      {/* Text overlay */}
      <p
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          zIndex: 1000,
        }}
        className="text-2xl text-gray-700"
      >
        {chatData?.event_venue}
      </p>

      {/* Leaflet map */}
      <MapContainer
        center={center}
        zoom={20}
        style={{ height: "300px", width: "100%" }}
        zoomControl={false}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <MapWithOffset center={markerPosition} />
      </MapContainer>
    </div>
  );
};

export default MyMap;
